<template>
    <section class="selection-panel" v-if="displayMsg">
        <span class="message">
			<span class="text">{{ msg }}</span>
		</span>
	</section>
    <section class="selection-panel" v-else-if="selected_count > 0">
        <span class="selected-count">
			<span class="count">{{ selected_count }}</span>
			<span class="text">{{ $t("labels.selected_count" ) }}</span>
		</span>
        <button class="deselect-all" @click="clearSelected">
            <span>{{ $t("labels.deselect_all") }}</span>
        </button>
        <button v-if="action == 'save'" class="save-to-list" @click="saveAllSelected">
            <span>{{ $t("labels.save_to_list") }}</span>
        </button>
        <button v-else class="remove-from-list" @click="removeAllSelected">
            <span>{{ $t("labels.remove_from_list") }}</span>
        </button>
    </section>
</template>

<script>
import { bus } from '../main'
import { mapGetters } from "vuex";
import SavedListMixin from '../mixins/SavedListMixin'

export default {
	name: "SelectedBar",
    mixins: [SavedListMixin],
	data () {
		return {
			msg: '',
			displayMsg: false,
		}
	},
    props:{
        action: {
            type: String,
            default: 'save'
        }
    },
	computed: {
		...mapGetters({
			selected_count: "list/selected_count",
		}),
	},
	created () {
		bus.$on('showMsg', (msg) => {
			this.msg = msg;
			this.displayMsg = true;

			setTimeout(() => {
				this.displayMsg = false
			}, 2500);
		})
	}
};
</script>

<style scoped lang="scss">

.selection-panel{
	position: sticky;
	bottom: 0;
	background-color: #93DA72;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding: 1.188rem 2.5rem;
	z-index: 5;

	&>*{
		margin-left: 1.25rem;
	}
	.selected-count{
		font-family: $arial;
		font-weight: 400;
		font-size: 1rem;
		color: $dark-gray1;

		.count{
			font-weight: 700;
			margin-right: 5px;
		}
	}

	.message .text {
		text-align: right;
		font-weight: 700;
	}

	button{
		background: transparent;
		cursor: pointer;
		border: 1px solid $dark-gray1;
		font-family: $arial;
		font-weight: 700;
		font-size: 0.688rem;
		line-height: 1;
		text-align: center;
		text-transform: uppercase;
		padding: 0.625rem 0.938rem;

		&.save-to-list,
		&.remove-from-list{
			background: #fff;
			border: 1px solid #fff;
		}
	}
}

@media(max-width: $mq-max-width-mobile){
	.selection-panel{
		padding-left: 1rem;
		padding-right: 1rem;
		justify-content: space-between;
	}
}
</style>
